import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';

const firebaseConfig = {
  apiKey: "AIzaSyD6p8IMxpWpAMYV_nXZGKFRWVI55suauLc",
  authDomain: "fridgelife-92624.firebaseapp.com",
  projectId: "fridgelife-92624",
  storageBucket: "fridgelife-92624.firebasestorage.app",
  messagingSenderId: "634276040729",
  appId: "1:634276040729:web:38ea817a5a8bcddeec1a88",
  measurementId: "G-YDWPSTV9D9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check
if (typeof window !== 'undefined') {
  // Enable debug token in development
  if (window.location.hostname === 'localhost') {
    // @ts-ignore
    (window as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }

  const recaptchaKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

  if (recaptchaKey && recaptchaKey !== 'YOUR_RECAPTCHA_SITE_KEY_HERE') {
    initializeAppCheck(app, {
      provider: new ReCaptchaV3Provider(recaptchaKey),
      isTokenAutoRefreshEnabled: true
    });
  } else {
    console.warn('App Check not initialized: Missing reCAPTCHA site key');
  }
}

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;